//export const API = ''
//export const API = '/api'
export const API =
  process.env.NODE_ENV === 'production'
    ? 'https://kaytee-international-38030.el.r.appspot.com/api'
    : 'http://localhost:8000/api'
